const fees = {
    standardFee: 0.001,
    createCard: 0.001,
    createBattle: 0.001,
    createAuction: 0.001
};

export default fees;


// WEBPACK FOOTER //
// ./src/util/constants/fees.js